import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import Store from './store'
import Style from './index.module.less'
import { LIVE_MANAGE_PATH, MARKETING_CENTER_PATH } from '@constant'
import { isStoreAccount } from '@util'

export default class extends Component {
  constructor() {
    super()
    this.store = new Store()
  }
  render() {
    const { sdk } = this.store
    return (
      <HeaderView
        title=""
        header={
          isStoreAccount()
            ? [
                <Link to={MARKETING_CENTER_PATH}>营销工具</Link>,
                <Link to={LIVE_MANAGE_PATH}>直播管理</Link>
              ]
            : ''
        }
      >
        <div className={Style.content}>
          <img src="//qnm.hunliji.com/o_1cr1r0hpin3m4kh1skkqhj14dki.jpg" />
          <img src="//qnm.hunliji.com/o_1cr1r0hpi1thpfj614nb1f21pc2j.jpg" />
          <img src="//qnm.hunliji.com/o_1cr1r0hpjpu01lpcr5d91l3svk.jpg" />
          <img src="//qnm.hunliji.com/o_1cr1r0hpj1dtn1id94id1hg31cotl.jpg" />
          <img src="//qnm.hunliji.com/o_1cr1r0hpjl3gis0gl81ttl11vjm.jpg" />
          <img src="//qnm.hunliji.com/o_1cr1r0hpjbc319lgu6d12901o4an.jpg" />
          <img src="//qnm.hunliji.com/o_1cr1r0hpjrmd1go48vg4mu1isbo.jpg" />
          <img src="//qnm.hunliji.com/o_1cr1r0hpj16he3u8i8j191d1ctjp.jpg" />
          <img src="//qnm.hunliji.com/o_1cr1r0hpj1l9p14evtj1b5416d4q.jpg" />
          <img src="//qnm.hunliji.com/o_1cr1r0hpj1sct1mmsd1i17fae22r.jpg" />
        </div>
        <div className={Style.route}>
          <Link
            className={Style.routeLink}
            onClick={sdk}
            to={`${LIVE_MANAGE_PATH}/purchase`}
          >
            <div className={Style.linkContent}>
              <img
                className={Style.image}
                src="//qnm.hunliji.com/o_1cr6tutc71fvuf2prsstg61ffm9.png"
              />
              <p className={Style.linkText}>
                <span className={Style.linkTextCommon}>首次体验特价低至</span>
                <img
                  className={Style.DINImage}
                  src="//qnm.hunliji.com/o_1cr73pk781jrv1c51i4slos1kkd9.png"
                />
                <span className={Style.linkTextCommon}>
                  原价<span style={{ textDecoration: 'line-through' }}>
                    16800
                  </span>
                </span>
              </p>
            </div>
            <div className={Style.routeBtn}>去购买</div>
          </Link>
        </div>
      </HeaderView>
    )
  }
}
